(function () {
	/* Toggle content */
	document.querySelectorAll('.product-description-more').forEach(function(el) {
		el.addEventListener('click', function(e) {
			e.preventDefault();
			var shortDesc = this.closest('.product-description-short');
			if (shortDesc) {
				var fullDesc = shortDesc.nextElementSibling;
				if (fullDesc) fullDesc.style.display = '';
				shortDesc.style.display = 'none';
			}
		});
	});

	document.querySelectorAll('.product-description-less').forEach(function(el) {
		el.addEventListener('click', function(e) {
			e.preventDefault();
			var fullDesc = this.closest('.product-description-full');
			if (fullDesc) {
				var shortDesc = fullDesc.previousElementSibling;
				if (shortDesc) shortDesc.style.display = '';
				fullDesc.style.display = 'none';
			}
		});
	});

	/* Toggle fields */
	document.querySelectorAll('.js-show-more').forEach(function(el) {
		el.addEventListener('click', function(e) {
			e.preventDefault();
			var parent = this.parentNode;
			parent.querySelectorAll('input').forEach(function(input) {
				input.classList.remove('hidden');
			});
			parent.querySelectorAll('label').forEach(function(label) {
				label.classList.remove('hidden');
			});
			this.remove();
		});
	});
})();

/* Second floated product form */
class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute('data-product-url'))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
				this.productElement = responseHTML.querySelector('div[id^="ProductInfo-"]');

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		// Security: Only re-inject scripts from trusted Shopify CDN origins or same-origin inline scripts.
		var trustedDomains = ['cdn.shopify.com', 'sdks.shopifycdn.com', 'monorail-edge.shopifysvc.com'];
		element.querySelectorAll('script').forEach(oldScriptTag => {
			var src = oldScriptTag.getAttribute('src') || '';
			if (src) {
				try {
					var scriptUrl = new URL(src, window.location.origin);
					var isTrusted = trustedDomains.some(function(d) { return scriptUrl.hostname === d || scriptUrl.hostname.endsWith('.' + d); });
					if (!isTrusted && scriptUrl.origin !== window.location.origin) return;
				} catch(e) { return; }
			}
			const newScriptTag = document.createElement('script');
			Array.from(oldScriptTag.attributes).forEach(attribute => {
				newScriptTag.setAttribute(attribute.name, attribute.value)
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `floated-${ sectionId }`);

		if (this.productElement.querySelectorAll('variant-selects')) {
			this.productElement.querySelectorAll('variant-selects').forEach(radio => {
				radio.dataset.originalSection = sectionId;
			});
		}

		if (this.productElement.querySelectorAll('variant-radios')) {
			this.productElement.querySelectorAll('variant-radios').forEach(radio => {
				radio.dataset.originalSection = sectionId;
			});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector('.product__text');
		if (text) text.remove();

		const shareButtons = this.productElement.querySelector('.share-buttons');
		if (shareButtons) shareButtons.remove();

		const rating = this.productElement.querySelector('.rating');
		if (rating) rating.remove();

		const tags = this.productElement.querySelector('.product-tags');
		if (tags) tags.remove();

		const description = this.productElement.querySelector('.product__description');
		if (description) description.remove();

		const advantage = this.productElement.querySelector('.advantage-wrapper');
		if (advantage) advantage.remove();

		const inventory = this.productElement.querySelector('.advantage');
		if (inventory) inventory.remove();

		const note = this.productElement.querySelector('.note');
		if (note) note.remove();

		const promoBanner = this.productElement.querySelector('.promo-banner');
		if (promoBanner) promoBanner.remove();

		const pickupAvailability = this.productElement.querySelector('pickup-availability');
		if (pickupAvailability) pickupAvailability.remove();

		const productModal = this.productElement.querySelector('product-modal');
		if (productModal) productModal.remove();

		const productForm = this.productElement.querySelector('floated-form');
		if (productForm) productForm.remove();

		const relatedProduct = this.productElement.querySelector('related-product');
		if (relatedProduct) relatedProduct.remove();

		const gift = this.productElement.querySelector('.customer');
		if (gift) gift.remove();

		const customLiquid = this.productElement.querySelector('.custom-liquid');
		if (customLiquid) customLiquid.remove();
	}

	showMoreFields() {
		this.querySelectorAll('.js-show-more').forEach(function(el) {
			el.addEventListener('click', function(e) {
				e.preventDefault();
				var parent = this.parentNode;
				parent.querySelectorAll('input').forEach(function(input) {
					input.classList.remove('hidden');
				});
				parent.querySelectorAll('label').forEach(function(label) {
					label.classList.remove('hidden');
				});
				this.remove();
			});
		});
	}
}

customElements.define('floated-form', FloatedForm);

